import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/metrix/')({
  component: RouteComponent,
});

function RouteComponent() {
  return 'Hello /_dashboard/dashboard/metrix/!';
}
